import script from "./ErrorDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorDialog.vue?vue&type=script&setup=true&lang=js"

import "./ErrorDialog.vue?vue&type=style&index=0&id=54ee6b26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54ee6b26"]])

export default __exports__